<script>
	import WatchObjects from "$lib/components/WatchObjects.svelte";
</script>

<svelte:head>
	<script src="https://cdn.jsdelivr.net/npm/@tailwindcss/browser@4"></script>
</svelte:head>

<WatchObjects />

<slot />
